module.exports = __webpack_public_path__ + "bed-quilt1-empty.a165afce.png";